import { Component, OnInit } from '@angular/core';
import {ConfService} from '../conf.service';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {AccountInfoService} from '../user/account-info.service';

@Component({
  selector: 'app-samples',
  templateUrl: './samples.component.html',
  styleUrls: ['./samples.component.scss']
})
export class SamplesComponent implements OnInit {

  responseFromAPI = [];
  responseFromDAAS = [];
  loading = true;

  samples = [{
    pageTitle: 'Data Access Service Samples',
    sampleType: 'DATAACCESS',
    samplesList: [],
  },
    {
      pageTitle: 'Business Logic Samples',
      sampleType: 'BUSINESSLOGIC',
      samplesList: [],
    },
    {
      pageTitle: 'Workflow Samples',
      sampleType: 'WORKFLOW',
      samplesList: [],
    },
    {
      pageTitle: 'SQL Query Samples',
      sampleType: 'SQL Query',
      samplesList: [],
    },
    {
      pageTitle: 'DMN Samples',
      sampleType: 'DMN',
      samplesList: [],
    }];
  constructor(private confPost: ConfService,
              public accountInfoService: AccountInfoService,
              public platform: LeftpanelComponent) { }

  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
    this.confPost.getEntitiesForPartnerAccount('samples', 'samples').subscribe(response => {
      if (response[0]) {
        const iterator = response[Symbol.iterator]();
        while (true) {
          const tempObject = iterator.next();
          if (tempObject.done) {
            break;
          }
          if (tempObject.value['category'] === 'Samples') {
            this.responseFromDAAS.push(tempObject.value);
          }
        }
        for (const entity of this.responseFromDAAS) {
          const DAASSample = {
            title : entity['displayname'],
            caption : entity['description'],
            documentRoute: '/docs/',
            doctitle: 'Data%20Access%20API',
            apiRoute: '/dataaccessapi',
            partner: 'samples',
            account: 'samples',
            entity: entity['entityname'],
            version: entity['version']
          };
          this.samples[0].samplesList.push(DAASSample);
        }
      }
    }, error => {
      this.loading = false;
      this.platform.openSnackBar('We are working on the samples. Please try again after sometime.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
    this.confPost.getApiExecutorsByPartnerAccount('samples', 'samples', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&fields=executor_name,executor_version,executor_method_type,executor_type,executor_scope,executor_description,executor_display_name,executor_category,service_provider,apiUrl,published,scopeOfAccess,registeredAsIs,creationTime,lastModifiedTime').subscribe(response => {
      if (response[0]) {
        const iterator = response[Symbol.iterator]();
        while (true) {
          const tempObject = iterator.next();
          if (tempObject.done) {
            break;
          }
          if (tempObject.value['executor_category'] === 'Samples') {
            this.responseFromAPI.push(tempObject.value);
          }
        }
        for (const executor of this.responseFromAPI) {
          if (executor['executor_type'] === 'BUSINESSLOGIC') {
            const BLSample = {
                title : executor['executor_display_name'],
                caption : executor['executor_description'],
                documentRoute: '/docs/',
                doctitle: 'Business%20Logic%20API',
                apiRoute: '/businesslogic',
                partner: 'samples',
                account: 'samples',
                entity: executor['executor_name'],
                version: executor['executor_version']
            };
            this.samples[1].samplesList.push(BLSample);
          }
          if (executor['executor_type'] === 'WORKFLOW') {
            const BLSample = {
              title : executor['executor_display_name'],
              caption : executor['executor_description'],
              documentRoute: '/docs/',
              // doctitle: 'Workflow%20Service',
              doctitle: '',
              apiRoute: '/workflow',
              partner: 'samples',
              account: 'samples',
              entity: executor['executor_name'],
              version: executor['executor_version']
            };
            this.samples[2].samplesList.push(BLSample);
          }
          if (executor['executor_type'] === 'SQLQUERY') {
            const BLSample = {
              title : executor['executor_display_name'],
              caption : executor['executor_description'],
              documentRoute: '/docs/',
              doctitle: 'SQL%20Query%20API',
              apiRoute: '/querybuilder',
              partner: 'samples',
              account: 'samples',
              entity: executor['executor_name'],
              version: executor['executor_version']
            };
            this.samples[3].samplesList.push(BLSample);
          }
          if (executor['executor_type'] === 'DMN') {
            const BLSample = {
              title : executor['executor_display_name'],
              caption : executor['executor_description'],
              documentRoute: '/docs/',
              // doctitle: 'Business%20Logic%20Service',
              doctitle: '',
              apiRoute: '/dmn',
              partner: 'samples',
              account: 'samples',
              entity: executor['executor_name'],
              version: executor['executor_version']
            };
            this.samples[4].samplesList.push(BLSample);
          }
        }
        this.loading = false;
      }
    }, error => {
      this.loading = false;
      this.platform.openSnackBar('We are working on the samples. Please try again after sometime.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

}
